import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from "@material-ui/core/Checkbox";
import TextField from '@material-ui/core/TextField';
import PressureCorrection from './PressureCorrection';
import HydrometerCorrection from './HydrometerCorrection';
import QuantityConversionService from '../../services/bunkermaster/QuantityConversionService';

import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import {
    VpsCommodity,
    VpsGravityType,
    VpsPressureUnit,
    VpsQuantityUnit
} from '../../services/bunkermaster/FuelMath';
import { TempType } from '../../services/bunkermaster/Settings'


import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";
import { template } from 'underscore';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(Parameter, Unit, Fuel1, Fuel2, Target, Blend) {
    return { Parameter, Unit, Fuel1, Fuel2, Target, Blend };
}

const rows = [
    createData('Density', 'Kg / m3', 990.0, 900.0, '', 939),
    createData('Flash Point', '^C', '', '', '', ''),
    createData('Viscosity', 'mm2/s', '180.0', '11.0', '', '25.8'),
    createData('Viscosity Temperature', '0C', '50', '50', '50', '50'),
    createData('Micro Carbon Residue', '%m/m', '', '', '', ''),
    createData('Sulphur', '%m/m', '', '', '', ''),
    createData('Vanadium', '%m/m', '', '', '', ''),
    createData('Sodium ', 'mg/kg', '', '', '', ''),
    createData('Aluminium + mg/kg', '', '', '', '', ''),
];



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    textstyles: {
        color: '#ff4717'
    }
}));

function GravityConversation() {
    const classes = useStyles();
    // // const [value, setValue] = React.useState(0);
    // // const handleChange = (event, newValue) => {
    // //     setValue(newValue);
    // //     setChecked(event.target.checked);
    // // };
    // // const [checked, setChecked] = React.useState(true);
    const [errs, setErrs] = useState([]);

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

     const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
        };

        const handleClose = () => {
            setOpen(false);
        };

        const descriptionElementRef = React.useRef(null);
        React.useEffect(() => {
            if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
            }
        }, [open]);

    const initialInputState = {
        commodity: VpsCommodity.RefinedProduct,
        gravityType: VpsGravityType.Density,
        gravityValue: '',
        gravityTempType: TempType.celcius,
        gravityTempValue: '15',
        gravityPressType: VpsPressureUnit.kPa,
        gravityPressValue: '0',
        obsQuantType: VpsQuantityUnit.CubicMetres,
        obsQuantValue: '',
        obsQuantTempType: TempType.celcius,
        obsQuantTempValue: '0',
        obsQuantPressType: VpsPressureUnit.kPa,
        obsQuantPressValue: '0',
        altType: VpsQuantityUnit.CubicMetres,
        altPressType: VpsPressureUnit.kPa,
        altPressValue: '0',
        altTempType: TempType.celcius,
        altTempValue: '0',
        pressCondn: true,
        disableObsTemp: false,
        disableAtlTemp: false
    };


    const initialOpState = {
        altValue: "",
        VCF: "",
        WCF: "",
        Mass_MT: ""
    };

    const [{
        commodity,
        gravityType,
        gravityValue,
        gravityTempType,
        gravityTempValue,
        gravityPressType,
        gravityPressValue,
        obsQuantType,
        obsQuantValue,
        obsQuantTempType,
        obsQuantTempValue,
        obsQuantPressType,
        obsQuantPressValue,
        altType,
        altPressType,
        altPressValue,
        altTempType,
        altTempValue,
        pressCondn,
        disableObsTemp,
        disableAtlTemp,
    }, setState] = useState(initialInputState);

    const [{
        altValue,
        VCF,
        WCF,
        Mass_MT
    }, setCalcValue] = useState(initialOpState);

    const onCalculateHandle = () => {
        ////
        QuantityConversionService.errors=[];
        const result = QuantityConversionService.Convert({
            commodity,
            gravityType,
            gravityValue,
            gravityTempType,
            gravityTempValue,
            gravityPressType,
            gravityPressValue,
            obsQuantType,
            obsQuantValue,
            obsQuantTempType,
            obsQuantTempValue,
            obsQuantPressType,
            obsQuantPressValue,
            altType,
            altValue,
            altPressType,
            altPressValue,
            altTempType,
            altTempValue,
            pressCondn
        });
        if ( QuantityConversionService.errors.length > 0) {
            const errs =  QuantityConversionService.errors.join("<br>");
            setErrs(errs);
        } else {
            setErrs("");
        }
        setCalcValue({ ...result });
    };

    const onChangeHandler = (name, value) => {

        switch (name) {
            case "gravityType": {
                if (value == VpsGravityType.Density) {
                    setState(prevState => ({
                        ...prevState,
                        [name]: value,
                        gravityTempValue: '15',
                        gravityTempType: TempType.celcius
                    }));
                } else {
                    setState(prevState => ({
                        ...prevState,
                        [name]: value,
                        gravityTempValue: '60',
                        gravityTempType: TempType.farenheit
                    }));
                }
            }
                break;

            case "obsQuantType": {
                //
                if (value == VpsQuantityUnit.CubicMetres) {
                    setState(prevState => ({
                        ...prevState,
                        [name]: value,
                        obsQuantTempValue: "0",
                        obsQuantTempType: TempType.celcius,
                        disableObsTemp: false
                    }));

                } else if (value == VpsQuantityUnit.MetricTons) {
                    setState(prevState => ({
                        ...prevState,
                        [name]: value,
                        obsQuantTempValue: "0",
                        obsQuantTempType: TempType.celcius,
                        disableObsTemp: true
                    }));

                } else {
                    setState(prevState => ({
                        ...prevState,
                        [name]: value,
                        obsQuantTempValue: "0",
                        obsQuantTempType: TempType.farenheit,
                        disableObsTemp: false
                    }));
                }
            }
                break;

            case "altType": {
                if (value == VpsQuantityUnit.CubicMetres) {
                    setState(prevState => ({
                        ...prevState,
                        [name]: value,
                        altTempValue: "0",
                        altTempType: TempType.celcius,
                        disableAtlTemp: false
                    }));

                } else if (value == VpsQuantityUnit.MetricTons) {
                    setState(prevState => ({
                        ...prevState,
                        [name]: value,
                        altTempValue: "0",
                        altTempType: TempType.celcius,
                        disableAtlTemp: true
                    }));

                } else {
                    setState(prevState => ({
                        ...prevState,
                        [name]: value,
                        altTempValue: "0",
                        altTempType: TempType.farenheit,
                        disableAtlTemp: false
                    }));
                }
            }
                break;

            default: {
                setState(prevState => ({ ...prevState, [name]: value }));
            }
        }


    };

    const onPressChange = (check) => {
        setState(prevState => ({ ...prevState, ["pressCondn"]: check }));
    }

    const onReset = () => {
        setErrs("");
        setState({ ...initialInputState });
        setCalcValue({ ...initialOpState });
    };

    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>Quantity Correction and Conversion </span>

                </div>

                <Box component="div" className="filtercontainer">
                    <Box component="div">

                        <Grid item xs={12} md={12}>


                            <Box component="div" className="bunkarinput">

                            <Box component="div" className="pos_relative">
                <Box component="div" className="help_blk">
                    <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>
                   
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        scroll={scroll}
                        aria-labelledby="scroll-dialog-title"
                        aria-describedby="scroll-dialog-description"
                    >
                        <DialogTitle id="scroll-dialog-title">Quantity Conversion and Correction</DialogTitle>
                        <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            tabIndex={-1}
                        >
                        <p>This module performs quantity conversions between different volume units and between volume units and metric tons (see example 1). It also performs volume corrections due to the influence of temperature and/or pressure (see example 2).</p>  
                            <p>The Correction Factor for Temperature and Pressure (CTPL or VCF) is calculated using the method specified in ASTM D 1250-04 and expressed with 5 decimal figures. Volume to weight conversions is performed by converting volumes to cubic meters @ 15°C and gravities to density @ 15°C. A weight factor is than determined in conformance with ASTM D 1250-80 Table 56 to obtain a weight in Metric Tons. Precision as expressed in number of decimal places can be set in the Properties module.

</p>
<p>For atmospheric pressure, enter zero in the pressure field or leave the field blank. For standard barge or ship tank measurements, pressure correction is not required. Applying Pressure Correction is switched off by default in Bunker Master. The calculations are then similar to the old 1980 tables.
</p>
                         <p className="subtitle">Example 1 - Conversion from volume to weight</p>
                         <img className="maxwidth100"  src="/assets/images/Quantity-Correction-Conversion-1.jpg"></img>
                        <p className="subtitle">Example 2 - Volume correction due to temperature influence</p>
                        <img className="maxwidth100"  src="/assets/images/Quantity-Correction-Conversion-2.jpg"></img>
                        
                         
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleClose}>Close</Button>
                        </DialogActions>
                    </Dialog>
                </Box>
                 </Box>



                                <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl}>

                                    <Grid container spacing={3}>

                                        <Grid item row xs={12} sm={12} md={12} lg={9}>

                                            <label className="widthauto">Commodity</label>
                                            <Select
                                                labelId="outlined-label7"
                                                className="mr20 bunkerselect"
                                                value={commodity}
                                                onChange={(e) => onChangeHandler("commodity", e.target.value)}
                                            >
                                                <MenuItem value={1}>Crude Oil</MenuItem>
                                                <MenuItem value={2}>Refined Products</MenuItem>
                                                <MenuItem value={3}>Lubricating Oil</MenuItem>
                                            </Select>
                                           

                                            <PressureCorrection
                                                // checked = {pressCondn} 
                                                onChange={onPressChange} />


                                            <p className="subtitle mt25 padb15">Gravity</p>
                                            <Select
                                                labelId="outlined-label6"
                                                className="mr20 bunkerselect inputwidth1"
                                                value={gravityType}
                                                onChange={(e) => onChangeHandler("gravityType", e.target.value)}>
                                                <MenuItem value={1}>Density, Kg/m3</MenuItem>
                                                <MenuItem value={2}>Specific Gravity</MenuItem>
                                                <MenuItem value={3}>API Gravity,  <sup>o</sup>API</MenuItem>
                                            </Select>
                                            <BootstrapInput
                                             type="number"
                                                className="mr20"
                                                value={gravityValue}
                                                onChange={(e) => onChangeHandler("gravityValue", e.target.value)} />
                                            at   <BootstrapInput
                                             type="number"
                                                className="mr20 smallbox"
                                                value={gravityTempValue}
                                                onChange={(e) => onChangeHandler("gravityTempValue", e.target.value)} />
                                            <Select
                                                labelId="outlined-label5"
                                                className="mr20 bunkerselect smallbox"
                                                value={gravityTempType}
                                                onChange={(e) => onChangeHandler("gravityTempType", e.target.value)} >
                                                <MenuItem value={1}> <sup>o</sup>C</MenuItem>
                                                <MenuItem value={2}> <sup>o</sup>F</MenuItem>
                                            </Select>
                                            and <BootstrapInput
                                             type="number"
                                                className="mr20 smallbox"
                                                value={gravityPressValue}
                                                onChange={(e) => onChangeHandler("gravityPressValue", e.target.value)}
                                                disabled={pressCondn} />
                                            <Select
                                                labelId="outlined-label5"
                                                className="mr20 bunkerselect smallbox"
                                                value={gravityPressType}
                                                onChange={(e) => onChangeHandler("gravityPressType", e.target.value)}
                                                disabled={pressCondn}>
                                                <MenuItem value={1}> kPa</MenuItem>
                                                <MenuItem value={2}> Bar</MenuItem>
                                                <MenuItem value={3}> Psi</MenuItem>
                                            </Select>
                                                {/* <span className="errortext   mt5"> Density is required.</span> */}

                                            <p className="subtitle mt25 padb15">Observed Quantity</p>
                                            <Select
                                                labelId="outlined-label4"
                                                className="mr20 bunkerselect inputwidth1"
                                                value={obsQuantType}
                                                onChange={(e) => onChangeHandler("obsQuantType", e.target.value)}>
                                                <MenuItem value={1}>Volume in Cubic Metres, m3</MenuItem>
                                                <MenuItem value={2}>Volume in Barrels, bbl</MenuItem>
                                                <MenuItem value={3}>Volume in US Gallons, usg</MenuItem>
                                                <MenuItem value={4}>Weight in Metric Tons, MT</MenuItem>
                                            </Select>
                                            <BootstrapInput  type="number" min="0" className="mr20"
                                                value={obsQuantValue}
                                                onChange={(e) => onChangeHandler("obsQuantValue", e.target.value < 0 ? (e.target.value = '') : e.target.value)} />
                                            at   <BootstrapInput
                                             type="number"
                                                className="mr20 smallbox"
                                                value={obsQuantTempValue}
                                                onChange={(e) => onChangeHandler("obsQuantTempValue", e.target.value)}
                                                disabled={disableObsTemp} />
                                            <Select
                                                labelId="outlined-label3"
                                                className="mr20 bunkerselect smallbox"
                                                value={obsQuantTempType}
                                                onChange={(e) => onChangeHandler("obsQuantTempType", e.target.value)}
                                                disabled={disableObsTemp} >
                                                <MenuItem value={1}> <sup>o</sup>C</MenuItem>
                                                <MenuItem value={2}> <sup>o</sup>F</MenuItem>
                                            </Select>
                                            and <BootstrapInput
                                             type="number"
                                                className="mr20 smallbox"
                                                value={obsQuantPressValue}
                                                onChange={(e) => onChangeHandler("obsQuantPressValue", e.target.value)}
                                                disabled={pressCondn} />
                                            <Select
                                                labelId="outlined-label5"
                                                className="mr20 bunkerselect smallbox"
                                                value={obsQuantPressType}
                                                onChange={(e) => onChangeHandler("obsQuantPressType", e.target.value)}
                                                disabled={pressCondn}>
                                                <MenuItem value={1}> kPa</MenuItem>
                                                <MenuItem value={2}> Bar</MenuItem>
                                                <MenuItem value={3}> Psi</MenuItem>
                                            </Select>
                                                {/* <span className="errortext   mt5"> Volume is required.</span> */}

                                            {/* <Box component="div" className="padb15">
                                                <HydrometerCorrection />
                                            </Box> */}

                                            <p className="subtitle mt25 padb15">Alternate Quantity</p>
                                            <Select
                                                labelId="outlined-label2"
                                                className="mr20 bunkerselect inputwidth1"
                                                value={altType}
                                                onChange={(e) => onChangeHandler("altType", e.target.value)}>
                                                <MenuItem value={1}>Volume in Cubic Metres, m3</MenuItem>
                                                <MenuItem value={2}>Volume in Barrels, bbl</MenuItem>
                                                <MenuItem value={3}>Volume in US Gallons, usg</MenuItem>
                                                <MenuItem value={4}>Weight in Metric Tons, MT</MenuItem>
                                            </Select>
                                            <BootstrapInput  type="number" className="mr20"
                                                value={altValue}
                                                disabled />
                                            {/* onChange={(e) => onChangeHandler("altValue", e.target.value)} */}
                                            at   <BootstrapInput
                                             type="number"
                                                                                            className="mr20 smallbox"
                                                value={altTempValue}
                                                onChange={(e) => onChangeHandler("altTempValue", e.target.value)}
                                                disabled={disableAtlTemp} />
                                            <Select
                                                labelId="outlined-label1"
                                                className="mr20 bunkerselect smallbox" 
                                                value={altTempType}
                                                onChange={(e) => onChangeHandler("altTempType", e.target.value)}
                                                disabled={disableAtlTemp} >
                                                <MenuItem value={1}> <sup>o</sup>C</MenuItem>
                                                <MenuItem value={2}> <sup>o</sup>F</MenuItem>
                                            </Select>
                                            and <BootstrapInput type="number"
                                             
                                                className="mr20 smallbox"
                                                value={altPressValue}
                                                onChange={(e) => onChangeHandler("altPressValue", e.target.value)}
                                                disabled={pressCondn} />
                                            <Select
                                                labelId="outlined-label5"
                                                className="mr20 bunkerselect smallbox"
                                                value={altPressType}
                                                onChange={(e) => onChangeHandler("altPressType", e.target.value)}
                                                disabled={pressCondn} >
                                                <MenuItem value={1}> kPa</MenuItem>
                                                <MenuItem value={2}> Bar</MenuItem>
                                                <MenuItem value={3}> Psi</MenuItem>
                                            </Select>
                                           {/* <span className="errortext   mt5"> Volume is required.</span> */}
                                            <span className="newerrortext">{errs}</span>
                                            <br></br><br></br>
                                            <Grid item xs={12} md={12} className="mb25 mt25">

                                                <button type="reset"
                                                    className={classes.btn1}
                                                    onClick={onReset}>Reset</button>
                                                <button
                                                    type="button"
                                                    className={classes.btn2}
                                                    onClick={onCalculateHandle}  >Calculate</button>{''}
                                            </Grid>


                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12} lg={3}>

                                            <Box component="div" className="resultbox">
                                                <p>Results</p>
                                                <Box component="div" className="bunkarinput resultinner">

                                                    <form className={classes.root} noValidate autoComplete="off">
                                                        <Box component="div" className="padbtm25 gravitymisc1">
                                                            <label className="resultLabel">VCF   </label>
                                                            <TextField id="standard-basic" value={VCF} />
                                                            <span className="resultmv"> </span>

                                                        </Box>
                                                        <Box component="div" className="padbtm25 gravitymisc1">
                                                            <label className="resultLabel">WCF   </label>
                                                            <TextField id="standard-basic" value={WCF} />
                                                            <span className="resultmv"> </span>

                                                        </Box>
                                                        <Box component="div" className=" gravitymisc1">
                                                            <label className="resultLabel"> Mass_MT  </label>
                                                            <TextField id="standard-basic" value={Mass_MT} />
                                                            <span className="resultmv"> </span>

                                                        </Box>
                                                    </form>
                                                </Box>



                                            </Box>

                                        </Grid>




                                    </Grid>

                                </FormControl>




                            </Box>


                        </Grid>




                    </Box>



                </Box>










            </div>
        </div>
    );
}
export default GravityConversation;
